import { create } from 'zustand';

export enum ModalType {
  Admin = 'Admin',
  Publisher = 'Publisher',
  Developer = 'Developer',
  Status = 'Status',
  Update = 'Update',
  Verification = 'Verification',
  AddPublisher = 'AddPublisher',
  AddAdmin = 'AddAdmin',
  whitelistUser = 'whitelistUser',
}

interface ModalState {
  activeModal: ModalType | null;
  toggleModal: (modalType: ModalType | null) => void;
  isModalActive: (modalType: ModalType) => (state: ModalState) => boolean;
}

export const modalStore = create<ModalState>((set) => ({
  activeModal: null,
  toggleModal: (modalType: ModalType | null) =>
    set((state) => ({
      activeModal: state.activeModal === modalType ? null : modalType,
    })),
  isModalActive: (modalType: ModalType) => (state: ModalState) =>
    state.activeModal === modalType,
}));
